import { render, staticRenderFns } from "./part-listpindaan.vue?vue&type=template&id=2e2687ea&"
import script from "./part-listpindaan.vue?vue&type=script&lang=js&"
export * from "./part-listpindaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports